import { DropdownKeys } from '@components/library/dropdown/index';

export const dropdownKeydownHelper = (
  keyPressed: DropdownKeys,
  optionsLength: number | undefined,
  targetedIndex: number | undefined,
): number | boolean => {
  if (optionsLength === undefined || targetedIndex === undefined) return false;

  const firstIndex = 0;
  const lastIndex = optionsLength - 1;
  const nextIndex = targetedIndex + 1;
  const previousIndex = targetedIndex - 1;

  switch (keyPressed) {
    case DropdownKeys.ArrowDown:
    case DropdownKeys.ArrowRight:
      if (targetedIndex > -1) {
        return (optionsLength > nextIndex) ? nextIndex : firstIndex;
      }
      return firstIndex;
    case DropdownKeys.ArrowLeft:
    case DropdownKeys.ArrowUp:
      if (targetedIndex > -1) {
        return targetedIndex === 0 ? lastIndex : previousIndex;
      }
      return lastIndex;
    case DropdownKeys.Backspace:
    case DropdownKeys.Enter:
    case DropdownKeys.Spacebar:
    case DropdownKeys.Space:
      if (targetedIndex > -1) {
        return true;
      }
      break;
    default:
      break;
  }

  return false;
};
